import * as React from 'react';
import {Typography} from "@mui/material";

export function SimpleComponentWithTitle({title, icon, children}: { children: React.ReactNode, icon?: React.ReactNode, title: string }) {

    return <div>
        <Typography variant="h2" className={"flex flex-row gap-4"}>{icon}{title}</Typography>
        {children}
    </div>;
}